import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import FeedbackCardContext from "../context";
import { Container, EmojiIcon, EmojiRow, LabelRow, Paragraph, Title } from "../styles";
import { Feedback, feedbackIconMap } from "../types";

const EmojiStep = () => {
  const theme = useContext(ThemeContext);
  const { copyConfig, handleFeedback } = useContext(FeedbackCardContext);
  const stepCopy = copyConfig.steps.Emoji;

  return /*#__PURE__*/(
    React.createElement(Container, null, /*#__PURE__*/
    React.createElement("div", null, /*#__PURE__*/
    React.createElement(Title, null, stepCopy.title), /*#__PURE__*/
    React.createElement(Paragraph, null, stepCopy.subtitle)), /*#__PURE__*/


    React.createElement("div", null, /*#__PURE__*/
    React.createElement(EmojiRow, null,
    Object.values(Feedback).map((nFeedback) => {
      const Icon = feedbackIconMap[nFeedback];

      return /*#__PURE__*/(
        React.createElement(EmojiIcon, {
          key: nFeedback,

          onClick: () => handleFeedback(nFeedback) }, /*#__PURE__*/

        React.createElement(Icon, { color: theme.colors['Level 5'] })));


    })), /*#__PURE__*/


    React.createElement(LabelRow, null, /*#__PURE__*/
    React.createElement(Paragraph, null, stepCopy.firstLabel), /*#__PURE__*/
    React.createElement(Paragraph, null, stepCopy.lastLabel)))));




};

export default EmojiStep;